import {
  CardForm,
  showNotification,
  NOTIFICATION_TYPE,
  Loader,
} from '@thinknet-gmbh/platform-common-ui';
import { ElementsConsumer, CardNumberElement, IbanElement } from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next';
import { useChangeStripeAccountAddress } from 'src/hooks/accounts/change-account-stripe-address.hook';
import { useGetStripeAccountAddress } from 'src/hooks/accounts/get-stripe-account-address.hook';

const StripeCardForm = ({
  onClose,
  onFinish,
}: {
  onClose: () => void;
  onFinish: (stripePaymentMethodId: string) => void;
}) => {
  const { t } = useTranslation();
  const { changeStripeAccountAddress, loading: changeStripeAddressLoading } =
    useChangeStripeAccountAddress();
  const { stripeAddress, loading: stripeAddressLoading } = useGetStripeAccountAddress();

  const handleSubmit = async (stripe: any, elements: any, values: any) => {
    const cardElement = elements?.getElement(CardNumberElement);
    const ibanElement = elements?.getElement(IbanElement);

    if (!stripe || !elements) return;

    await changeStripeAccountAddress({
      variables: {
        payload: {
          company: values.company,
          street: values.street,
          zipCode: values.zipCode,
          city: values.city,
          country: values.country,
        },
      },
    });

    const stripeResponse = await stripe.createPaymentMethod({
      type: !values.email ? 'card' : 'sepa_debit',
      ...(!values.email ? { card: cardElement } : { sepa_debit: ibanElement }),
      billing_details: {
        name: values.cardholder || values.accountHolder,
        email: values.email,
      },
    });
    const { error, paymentMethod } = stripeResponse;

    if (
      error ||
      !paymentMethod ||
      (paymentMethod.card && !paymentMethod.card.three_d_secure_usage.supported)
    ) {
      return showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        ...(error && { description: error.message || error.errorMessage }),
      });
    }

    onFinish(paymentMethod.id);
  };

  if (stripeAddressLoading) return <Loader />;

  return (
    <div style={{ position: 'relative' }}>
      {changeStripeAddressLoading && <Loader position="absolute" />}
      <ElementsConsumer>
        {({ stripe, elements }: any) => (
          <CardForm
            t={t}
            onClose={onClose}
            handleSubmit={handleSubmit}
            stripe={stripe}
            elements={elements}
            initialData={{ ...stripeAddress }}
          />
        )}
      </ElementsConsumer>
    </div>
  );
};

export default StripeCardForm;
